(async () => {
    try {
        const response = await fetch('/svg-sprite.svg');
        const body = await response.text();

        const container = document.createElement('div');
        container.style.display = 'none';
        container.innerHTML = body;

        document.body.appendChild(container);
    } catch (error) {
        console.log(error); // eslint-disable-line
    }
})();
